import { useMutation } from 'react-query';
import {
  createStudentRecognitionAsync,
  getAllStudentsByLicenseAsync,
  getAllStudentsForSelectionAsync,
  getStudentRecognitionByIdAsync,
  updateStudentRecognitionAsync,
} from '../../index';

export const useCreateStudentRecognitionAsync = () =>
  useMutation(createStudentRecognitionAsync);

export const useUpdateStudentRecognitionAsync = () =>
  useMutation(updateStudentRecognitionAsync);

export const useGetStudentRecognitionByIdAsync = () =>
  useMutation(getStudentRecognitionByIdAsync);

export const useGetAllStudentsByLicenseMutateAsync = () =>
  useMutation(getAllStudentsByLicenseAsync);

export const useGetAllStudentsForSelectionMutateAsync = () => {
  return useMutation(getAllStudentsForSelectionAsync);
};